

<hyperkit-typography variant="label1" align="left" color="primary">{{label}}</hyperkit-typography>
